import { Error404Fragment, withErrorLayout } from ".";
import { VolunteerSearchLink } from "..";

export const OpportunityDetails404Fragment = (): JSX.Element => {
  return (
    <Error404Fragment title="This opportunity has gone">
      <p>Sorry this opportunity is no longer available.</p>
      <p>
        You can{" "}
        <VolunteerSearchLink
          to="/volunteering"
          searchQuery={{}}
          searchType="opp"
        >
          search for current opportunities
        </VolunteerSearchLink>
        .
      </p>
    </Error404Fragment>
  );
};

export const OpportunityDetails404 = withErrorLayout(
  OpportunityDetails404Fragment,
  404
);
